import { Link } from "react-router-dom";
import { UserType } from "../../../types/userType";
import Avatar from "../../common/Avatar";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getLastMessage } from "../../../functions/getLastMessage";

interface props {
  selected: boolean;
  data: UserType;
  isContact: boolean;
}

const UserCard = ({ selected, data, isContact }: props) => {
  const messages = useSelector((state: RootState) => state.messages.messages);

  return (
    <Link
      to={`/${data.id}`}
      className={`${
        selected
          ? "bg-violet-500 text-white"
          : "text-slate-600 hover:bg-slate-100"
      } p-[10px] grid grid-cols-10 rounded-md text-left`}
    >
      <div className="col-span-2 items-center flex">
        <Avatar
          isSmall={false}
          data={data}
          activeStatus={data.isActive && true}
        />
      </div>

      <div className="col-span-7 flex flex-col justify-center">
        <h6 className="text-[14px] font-medium">{data.name}</h6>
        {!isContact && (
          <p
            className={`${selected ? "text-white" : "text-slate-500"} text-sm`}
          >
            {getLastMessage(data.id, messages)}
          </p>
        )}
      </div>

      <div className="col-span-1 flex flex-col justify-center -mt-1 gap-1">
        {!isContact && (
          <span
            className={`text-xs ${selected ? "text-white" : "text-slate-400"}`}
          >
            2hr
          </span>
        )}

        {data.unSeen === 0 || isContact ? null : (
          <span
            className={`text-[9px] w-4 h-4 flex justify-center items-center rounded-full ${
              selected ? "text-violet-500 bg-white" : "text-white bg-violet-500"
            }`}
          >
            {data.unSeen}
          </span>
        )}
      </div>
    </Link>
  );
};

export default UserCard;
